/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type TenantConfigUpdateRequestDto = {
  whitelabelEnabled?: boolean;
  snsPlatformEndpointArn?: string;
  otpHashCode?: string;
  appName?: string;
  appHardUpdateVersion?: string;
  /**
   * SMS provider
   */
  smsProvider: TenantConfigUpdateRequestDto.smsProvider;
  /**
   * Date when 'Privacy policy' and/or 'Terms of use' have been changed.
   */
  legalDocUpdatedAt?: string;
  /**
   * Phone number to show when executing emergency calls
   */
  callerPhoneNumber?: string;
  userLimit?: number;
};
export namespace TenantConfigUpdateRequestDto {
  /**
   * SMS provider
   */
  export enum smsProvider {
    LMT = 'LMT',
    AWS = 'AWS',
  }
}

